module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-08.17d21297.jpg";